
import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'
import user from './user'

const reducers = combineReducers({
  user,
  routing //: routerReducer
});

export default reducers



// WEBPACK FOOTER //
// ./src/state/index.js